<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !lock">

          <div class="footer theme-base-bg-color" :style="inPreview ? getThemeInlineStyle('background-color', 'base') : ''">
            <nav class="footer-nav theme-main-bg-color" :style="inPreview ? getThemeInlineStyle('background-color', 'main') : ''">
              <div class="footer-nav-inner">
                <div :class="['grid', 'grid-1-2-m', 'grid-1-' + chunksPages.length + '-l']">
                  <template v-for="(chunk, i) in chunksPages">
                    <div>
                      <ul class="nav-list flex column">
                        <template v-for="(page, j) in chunk">
                          <template v-if="+page.parent === 0">
                            <li class="nav-item" :key="i * chunkLength + j">
                              <a class="nav-item-a">{{ page.title.rendered }}<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                            </li>
                          </template>
                          <template v-else>
                            <li class="nav-sub-item" :key="i * chunkLength + j">
                              <a class="nav-sub-item-a">{{ page.title.rendered }}</a>
                            </li>
                          </template>
                        </template>
                      </ul>
                    </div>
                  </template>
                </div>
                <!-- <ul :class="['nav-list', 'items-' + parseInt(publishedPages.reduce((prev, curr) => curr.items ? prev + 1 + curr.items.reduce((p, c) => p + 1, 0) : prev + 1, 0) / 4) + '-per-col']">
                  <template v-for="(page, i) in publishedPages">
                    <template v-if="+page.parent === 0">
                      <li class="nav-item" :key="i">
                        <a class="nav-item-a">{{ page.title.rendered }}<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                      </li>
                    </template>
                    <template v-else>
                      <li class="nav-sub-item" :key="i">
                        <a class="nav-sub-item-a">{{ page.title.rendered }}</a>
                      </li>
                    </template>
                  </template>
                </ul> -->
              </div>
            </nav>

            <div class="footer-info">
              <div class="footer-info-inner flex column-reverse justify-between items-center row-m">
                <div class="footer-info-address">
                  <a class="footer-info-a">
                    <template v-if="logo.src">
                      <mimic-amp-img :image="logo"></mimic-amp-img>
                    </template>
                    <template v-else>
                      <div style="color:red">Settingsでロゴを設定して選択してください。</div>
                    </template>
                  </a>
                  <p class="footer-info-p">
                    <template v-if="fullAddress">
                      <span>{{ fullAddress }}</span>
                    </template>
                    <template v-else>
                      <span style="color:red">Settingsで所在地を設定してください</span>
                    </template>
                  </p>
                  <p class="footer-info-p">
                    <template v-if="contact.tel">
                      <span>TEL：{{ contact.tel }}</span>
                    </template>
                    <template v-else>
                      <span style="color:red">Settingsで電話番号を設定してください</span>
                    </template>
                    <template v-if="contact.fax">
                      <span>FAX：{{ contact.fax }}</span>
                    </template>
                  </p>
                  <p class="footer-info-p">
                    <template v-if="contact.email">
                      <span>e-mail：{{ contact.email }}</span>
                    </template>
                    <template v-else>
                      <span style="color:red">Settingsでメールアドレスを設定してください</span>
                    </template>
                  </p>
                </div>
                <div class="footer-info-links">
                  <template v-for="id in contents.linkIds">
                    <a class="footer-info-link theme-accent-color theme-accent-border-color theme-accent-bg-color-hover" :style="inPreview ? getThemeInlineStyle('color', 'accent') : ''">{{ getPageById(id).title.rendered }}</a>
                  </template>
                  <div class="footer-info-sns-wrapper flex justify-center items-center">
                    <template v-if="settings.facebook && settings.facebook.id">
                      <a class="footer-info-sns"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                    </template>
                    <template v-if="settings.twitter && settings.twitter.owner">
                      <a class="footer-info-sns"><i class="fa fa-twitter" aria-hidden="true"></i></a>
                    </template>
                    <template v-if="settings.instagram && settings.instagram.id">
                      <a class="footer-info-sns"><i class="fa fa-instagram" aria-hidden="true"></i></a>
                    </template>
                    <template v-if="settings.youtube && settings.youtube.channelId">
                      <a class="footer-info-sns"><i class="fa fa-youtube" aria-hidden="true"></i></a>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-copyright theme-accent-bg-color" :style="inPreview ? getThemeInlineStyle('background-color', 'accent') : ''">
              <p class="footer-copyright-p">© {{ owner }} All Rights Reserved.</p>
            </div>
          </div>
        </div>

      </div>
      <el-dialog width="75%" title="フッターコンポーネントのコンテンツを編集" :visible.sync="isEditing">
        <el-form :model="contents">
          <el-form-item label="リンクボタンの追加 (2つまで)" :label-width="labelWidth">
            <select-links :limit="2" v-model="contents.linkIds"></select-links>
          </el-form-item>
          <!-- <el-form-item label="著作権表示の背景色" label-width="120px">
            <el-input class="width-50" v-model="contents.copyright.bg" auto-complete="off"></el-input>
          </el-form-item> -->
        </el-form>
        <span slot="footer" class="dialog-footer">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </span>
      </el-dialog>
    </template>
  </div>
</template>

<script>
import chunk from 'lodash/chunk'
import ComponentBase from '@/components/mixins/ComponentBase'
import MimicAmpImg from '@/components/mimic-amp/MimicAmpImg'
import SelectLinks from '@/components/forms/SelectLinks'

export default {
  name: 'footer-company-1',
  components: {
    'mimic-amp-img': MimicAmpImg,
    'select-links': SelectLinks
  },
  data: function () {
    return {
      labelWidth: '15em'
    }
  },
  mixins: [ComponentBase],
  computed: {
    logo: function () {
      return this.$store.getters['wordpress/settings/logo']
    },
    contact: function () {
      return this.$store.getters['wordpress/settings/contact']
    },
    owner: function () {
      return this.$store.getters['wordpress/settings/owner']
    },
    fullAddress: function () {
      return this.$store.getters['wordpress/settings/fullAddress']
    },
    chunkLength: function () {
      return Math.ceil(this.publishedPages.length / 4)
    },
    chunksPages: function () {
      return chunk(this.publishedPages, this.chunkLength)
    }
  },
  methods: {
    /**
     * コンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      let infoLinks = ''
      contents.linkIds.forEach(id => {
        if (!this.getPageById(id)) return

        infoLinks += `<a class="footer-info-link theme-accent-color theme-accent-border-color theme-accent-bg-color-hover" href="${this.getPageById(id).link}">${this.getPageById(id).title.rendered}</a>`
      })

      let facebook = this.settings.facebook && this.settings.facebook.id ? `<a class="footer-info-sns" href="https://www.facebook.com/${this.settings.facebook.id}" target="_blank"><i class="fa fa-facebook" aria-hidden="true"></i></a>` : ''
      let twitter = this.settings.twitter && this.settings.twitter.owner ? `<a class="footer-info-sns" href="https://twitter.com/${this.settings.twitter.owner}" target="_blank"><i class="fa fa-twitter" aria-hidden="true"></i></a>` : ''
      let instagram = this.settings.instagram && this.settings.instagram.id ? `<a class="footer-info-sns" href="https://www.instagram.com/${this.settings.instagram.id}" target="_blank"><i class="fa fa-instagram" aria-hidden="true"></i></a>` : ''
      let youtube = this.settings.youtube && this.settings.youtube.channelId ? `<a class="footer-info-sns" href="https://www.youtube.com/channel/${this.settings.youtube.channelId}" target="_blank"><i class="fa fa-youtube" aria-hidden="true"></i></a>` : ''

      const html = `
      <footer class="footer theme-base-bg-color">
        <nav class="footer-nav theme-main-bg-color">
          <div class="footer-nav-inner">getNavListType1</div>
        </nav>
        <div class="footer-info">
          <div class="footer-info-inner flex column-reverse justify-between items-center row-m">
            <div class="footer-info-address">
              <a class="footer-info-a" href="${this.url}">
                <amp-img width="${this.logo.width}" height="${this.logo.height}" layout="responsive" src="${this.logo.src}" alt="${this.settings.site.owner}ロゴ画像" attribution="${this.settings.site.owner} All Rights Reserved."><p fallback>${this.owner}</p>
                </amp-img>
              </a>
              <p class="footer-info-p">${this.fullAddress}</p>
              <p class="footer-info-p">TEL：${this.contact.tel} FAX：${this.contact.fax}</p>
              <p class="footer-info-p">e-mail：${this.contact.email}</p>
            </div>
            <div class="footer-info-links">
              ${infoLinks}
              <div class="footer-info-sns-wrapper flex justify-center items-center">
                ${facebook}
                ${twitter}
                ${instagram}
                ${youtube}
              </div>
            </div>
          </div>
        </div>
        <div class="footer-copyright theme-accent-bg-color">
          <p class="footer-copyright-p">© ${this.owner} All Rights Reserved.</p>
        </div>
      </footer>`
      return html.replace(/>\s+</g, '><').replace(/(\r\n|\n|\r)/gm, '').replace(/^\s+|\s+$/g, '')
    },
    /**
     * コンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      let theme = ''
      return {layout, theme}
    }
  },
  created: function () {
    // 固定ページが見つからなければcontents.linkIdsから削除する
    this.component.contents.linkIds = this.component.contents.linkIds.filter(id => this.getPageById(id))
  }
}
</script>

<style lang="scss" scoped>
.native {
  @import "./FooterCompany1.scss";
}
.smartphone,
.tablet,
.desktop {
  @import "./FooterCompany1.s.scss";
}
.tablet,
.desktop {
  @import "./FooterCompany1.m.scss";
}
.desktop {
  @import "./FooterCompany1.l.scss";
}
</style>



// WEBPACK FOOTER //
// src/components/footer/FooterCompany1/FooterCompany1.vue